import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from '../../../components/ui/LanguageSelector';
import { translateStaticText } from '../../../config/staticAssessmentTranslations';

const sections = [
  {
    icon: '💻',
    name: 'Technical Knowledge',
    detail: 'CS fundamentals, OOP, DBMS, DS&A'
  },
  {
    icon: '🔍',
    name: 'Analytical Thinking',
    detail: 'Case-based reasoning, root cause analysis'
  },
  {
    icon: '💬',
    name: 'Communication Skills',
    detail: 'Business writing, email tone, clarity'
  },
  {
    icon: '👥',
    name: 'Team & Leadership',
    detail: 'Collaboration, delegation, conflict resolution'
  },
  {
    icon: '⚖️',
    name: 'Professional Ethics',
    detail: 'Integrity, data privacy, ethical dilemmas'
  }
];

export default function IntroPage() {
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState('en');

  const displaySections = sections.map((section) => ({
    ...section,
    name: translateStaticText(section.name, currentLanguage),
    detail: translateStaticText(section.detail, currentLanguage),
    questionCountLabel: translateStaticText('10 questions', currentLanguage)
  }));

  return (
    <div className="min-h-screen skill-intro-bg px-4 py-12 flex items-center justify-center">
      <div className="w-full max-w-3xl text-center">
        <div className="flex justify-end mb-4">
          <LanguageSelector
            currentLanguage={currentLanguage}
            onLanguageChange={setCurrentLanguage}
            isTranslating={false}
          />
        </div>
        <h1 className="font-jakarta text-4xl md:text-5xl text-white skill-fade-in">{translateStaticText('ProEdge Skill Assessment', currentLanguage)}</h1>
        <p className="mt-3 text-white/75">{translateStaticText('5 Sections · 50 Questions · ~50 minutes', currentLanguage)}</p>

        <div className="mt-10 grid gap-3 max-w-2xl mx-auto">
          {displaySections.map((section, index) => (
            <div
              key={`${index}_${section.icon}`}
              className="skill-intro-item rounded-xl border border-white/20 bg-white/10 backdrop-blur-xl px-4 py-4 text-left transition-opacity duration-200"
              style={{ animationDelay: `${0.4 * index}s` }}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 text-white">
                  <span className="text-xl" aria-hidden="true">{section.icon}</span>
                  <span className="font-medium">{section.name}</span>
                </div>
                <span className="text-sm text-white/60">{section.questionCountLabel}</span>
              </div>
              <p className="mt-1.5 text-xs text-white/70">{section.detail}</p>
              <div className="mt-2 h-2 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full w-[30%] bg-emerald-400 inline-block" />
                <div className="h-full w-[40%] bg-teal-500 inline-block" />
                <div className="h-full w-[30%] bg-cyan-600 inline-block" />
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => navigate('/assessment/skill/test')}
          className="mt-10 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 px-8 py-3 text-white font-semibold shadow-lg shadow-emerald-500/40 skill-begin-btn"
        >
          {translateStaticText('Begin Assessment →', currentLanguage)}
        </button>
      </div>
    </div>
  );
}
